export default "__VITE_ASSET__DeszaUlr__"